import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CompanyRecord, CompanyRow } from '@shared/interface/company';

@Injectable({
  providedIn: 'root',
})
export class CompanyContext {
  private readonly _company$ = new BehaviorSubject<CompanyRecord | null>(null);
  readonly company$ = this._company$.asObservable();

  setCompany(company: CompanyRecord | null) {
    this._company$.next(company);
  }

  get company(): CompanyRecord | null {
    return this._company$.value;
  }

  clear() {
    this._company$.next(null);
  }
}
